import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: ${(props) => props.theme.fonts.base};
  }

  html, body {
    overflow-x: hidden;
    width: 100%;
     background-color: ${(props) => props.theme.colors.extralight};
    color: ${(props) => props.theme.colors.dark};
    display: flex;
    flex-direction: column;
  }

  h1, h2, h3, h4, h5, h6, strong, b {
    font-weight: bold;
  }

  /* ✅ Global Custom Scrollbar Styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.secondary};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors.dark};
  }
`;

export default GlobalStyle;
